import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider, useSelector } from "react-redux";
import store from "./store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MantineProvider } from "@mantine/core";
import { decrypt } from "./utils";
import { GOOGLE_CLIENT_ID_ENC } from "./constants";

const Main = () => {
  const theme = useSelector((state) => state.theme);
  return (
    <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
      <App />
    </MantineProvider>
  );
};

const googleClientId = decrypt(GOOGLE_CLIENT_ID_ENC);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={googleClientId}>
      <Main />
    </GoogleOAuthProvider>
  </Provider>,
);

reportWebVitals();
